import { render, staticRenderFns } from "./loan-purpose-popup.vue?vue&type=template&id=465cd3f6&"
import script from "./loan-purpose-popup.vue?vue&type=script&lang=ts&"
export * from "./loan-purpose-popup.vue?vue&type=script&lang=ts&"
import style0 from "./loan-purpose-popup.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports